import { render } from "./Header.vue?vue&type=template&id=f9c96486"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=f9c96486&lang=css"

import exportComponent from "/var/www/clients/client5/web28/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__